import { Autocomplete, Box, TextField, ThemeProvider, useTheme } from '@mui/material'
import React, { useEffect, useState } from 'react'
import estados from '../lib/estados'
import customTheme from '../lib/customTheme';
import mobile from '../lib/mobile';

const SelectEstado = ({ onSelect = () => { } }) => {
    // const outerTheme = useTheme();
    const [isMobile, setIsMobile] = useState(false);
    useEffect(() => {
        setIsMobile(mobile());
    }, []);
    return (
        <Box>
            {/* <ThemeProvider
                theme={customTheme(outerTheme)}
            > */}
            <Autocomplete
                onChange={(e, newVal) => onSelect(newVal)}
                disablePortal
                options={estados.map(estado => estado.nombre)}
                sx={{
                    width: isMobile ? '100%' : 300,
                }}
                renderInput={(params) => <TextField variant="standard" {...params} label="Entidad Federativa" />}
            />
            {/* </ThemeProvider> */}
        </Box>
    )
}

export default SelectEstado